'use client'

import { ToolAuthDialog } from '@/components/marketing/tools/tool-auth-dialog'

/** Tool-page auth modal for any fal-backed studio. See {@link ToolAuthDialog}. */
export function FalToolAuthDialog({
  open,
  onOpenChange,
  toolTitle,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  toolTitle: string
}) {
  return (
    <ToolAuthDialog
      open={open}
      onOpenChange={onOpenChange}
      description={`Create your Soku AI account to use the ${toolTitle}. You stay right on this page.`}
    />
  )
}
